<template lang="pug">
.top
  g-header
  .title
    span あなた
    span の
    span 鐔ｭЖ_診断
  form.form(@submit.prevent="send")
    .form__prompt あなたの名前を_〓?∵ください
    .text-input
      input(type="text" name="name" placeholder="あなたの名前" v-model="name")
    .submit-button
      button.submit-button__label ★診断する
    broken-banner.banner-bug--n1(:width="338" :height="59")
  .share-unit
    .share-unit__column: tweet-button(
      :url="shareUrl"
      :text="shareText"
      :hashtags="shareHashtags"
      @click="sendShareEvent('twitter')"
    )
    .share-unit__column: line-it-button(:url="shareUrl")
    .share-unit__column: like-button(:url="shareUrl")
    .share-unit__column(@click="sendShareEvent('hatena')"): hatena-button(:url="shareUrl")
  .footer
    broken-banner.banner-bug--n2(:width="262" :height="110")
    broken-banner.banner-bug--n3(:width="337" :height="59")
    a.footer__link(:href="linkYonimo" target="_blank")
      | presented by 世にも奇妙な物語
      br
      | .
      br
      | .
      br
      | .
  .loading(v-if="isLoading")
    .loading__anim
    .loading__label 診断中...
  transition
    sound-modal(v-if="isSoundModalShown && !soundFlag" @close="send")
</template>

<script>
import { mapState, mapActions } from "vuex";

import TweetButton from "@/components/TweetButton";
import LikeButton from "@/components/LikeButton";
import LineItButton from "@/components/LineItButton";
import HatenaButton from "@/components/HatenaButton";
import SoundModal from "@/components/SoundModal";
import GHeader from "@/components/GHeader";
import BrokenBanner from "@/components/BrokenBanner";
import commonConfig from "@/mixin/commonConfig";

export default {
  name: "top",
  components: {
    TweetButton,
    LikeButton,
    LineItButton,
    HatenaButton,
    SoundModal,
    GHeader,
    BrokenBanner
  },
  mixins: [commonConfig],
  data: () => ({
    name: null,
    isSoundModalShown: false,
    isLoading: false
  }),
  computed: {
    ...mapState(["soundFlag"])
  },
  methods: {
    ...mapActions(["registerUserName"]),
    send() {
      if (this.isLoading || !this.name) return;

      gtag("event", "goout", {
        event_category: "start"
      });

      const name = this.name.length > 10 ? this.name.slice(0, 10) : this.name;
      this.registerUserName(name);

      // サウンドをONにするまで先に進めない感じになるけどまあいいか
      if (!this.soundFlag) {
        this.isSoundModalShown = true;
        return;
      }
      this.isLoading = true;

      const delay = 1000 + 1000 * Math.random();
      setTimeout(() => {
        this.$router.push({ name: "result" });
      }, delay);
    },
    sendShareEvent(sns) {
      gtag("event", "btn", {
        event_category: `top-${sns}`
      });
    }
  },
  mounted() {
    this.registerUserName(null);
  }
};
</script>

<style lang="scss" scoped>
.top {
  position: relative;
}

.title {
  width: 10em;
  margin-left: 30px;
  @include font-mincho;
  -webkit-font-smoothing: never;
  font-weight: 900;
  font-size: 75px;
  line-height: 1;
  transform-origin: 0% 0%;
  transform: scaleX(0.3);
  span {
    display: inline-block;
    &:nth-child(2) {
      transform: rotate(180deg) translateY(-30%);
    }
    &:nth-child(3) {
      transform: translateY(-35%);
    }
  }
}

.form {
  position: relative;
  margin: 80px 0px;
}
.form__prompt {
  font-size: 15px;
  font-style: italic;
}

.text-input {
  display: flex;
  height: 39px;
  margin: 15px;
  margin-left: 30px;
  border: solid 1.5px #000;
  border-radius: 6px;
  input {
    position: relative;
    width: 100%;
    height: 76px;
    appearance: none;
    background-color: transparent;
    border: none;
    font-size: 18px;
    transform-origin: 0% 0%;
    transform: scaleY(0.5);
    text-indent: 0.8em;
  }
}

.submit-button {
  background-color: #f00;
  width: 200px;
  margin: auto;
  padding: 2px 20px;
  padding-bottom: 6px;
  border-radius: 10px;
}
.submit-button__label {
  appearance: none;
  border: none;
  background-color: transparent;
  text-decoration: underline;
  color: #00f;
  font-size: 20px;
  line-height: 23px;
  font-weight: 900;
  @include font-mincho;
  transform-origin: 0% 0%;
  transform: scaleX(2.5);
}

.share-unit {
  display: flex;
  justify-content: flex-end;
  margin: 15px;
  margin-top: 80px;
  margin-bottom: 120px;
  transform-origin: 100% 0%;
  transform: scaleX(0.5);
}
.share-unit__column {
  margin-right: 1em;
  &:last-child {
    margin-right: 0;
    transform: translate(-40px, 50px);
  }
}

.banner-bug {
  position: absolute;
}
.banner-bug--n1 {
  @extend .banner-bug;
  bottom: -205px;
  left: 15px;
}
.banner-bug--n2 {
  @extend .banner-bug;
  top: -10px;
  right: 0;
}
.banner-bug--n3 {
  @extend .banner-bug;
  top: 18px;
  right: 8px;
}

.footer {
  position: relative;
  padding-top: 115px;
  padding-bottom: 50px;
  background-image: image-url("bg.gif");
  background-size: 200px 200px;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
}
.footer__link {
  color: #fff;
  @include font-mincho;
}

.loading {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.8);
}

.loading__anim {
  width: 50px;
  height: 50px;
  margin-bottom: 30px;
  background-image: image-url("loading.gif");
  background-size: contain;
  background-repeat: no-repeat;
}

.loading__label {
  color: #fff;
  font-size: 20px;
  font-style: italic;
}
</style>
